interface Change {
  start: number;
  end: number;
  content: string;
}

export default class MagicString {
  str: string;
  changes: Change[];

  constructor(code: string) {
    this.str = code;
    this.changes = [];
  }

  get hasChanges() {
    return this.changes.length > 0;
  }

  replace(start: number, end: number, content: string) {
    this.changes.push({ start, end, content });
  }

  insert(index: number, content: string) {
    this.replace(index, index, content);
  }

  append(content: string) {
    const { length } = this.str;
    this.insert(length, content);
  }

  toString() {
    // TODO: switch to a rope data structure to support overlapping changes in sub regions
    const sorted = [...this.changes].sort((a, b) => a.start - b.start);

    let result = this.str;
    let offset = 0;

    for (const change of sorted) {
      result = result.slice(0, change.start + offset) + change.content + result.slice(change.end + offset);
      offset += change.content.length - (change.end - change.start);
    }

    return result;
  }
}
